type Region = {
	readonly id: string;
	readonly apiUrl: string;
	readonly shopifyShopDomain: string;
	readonly storefrontAccessToken: string;
	readonly storeAddToCartUrl: string;
};

function parseJsonRegions(source: string): readonly Region[] {
	const raw = JSON.parse(source);
	if (!Array.isArray(raw)) {
		throw new Error(`Regions not array: ${source}`);
	}

	return raw.map((r) => {
		if (typeof r !== "object" || !r) {
			throw new Error(`Region item not object: ${source}`);
		}
		if (
			typeof r.id !== "string" ||
			typeof r.apiUrl !== "string" ||
			typeof r.shopifyShopDomain !== "string" ||
			typeof r.storefrontAccessToken !== "string" ||
			typeof r.storeAddToCartUrl !== "string"
		) {
			throw new Error(`Region item invalid: ${source}`);
		}
		return {
			id: r.id as string,
			apiUrl: r.apiUrl as string,
			shopifyShopDomain: r.shopifyShopDomain as string,
			storefrontAccessToken: r.storefrontAccessToken as string,
			storeAddToCartUrl: r.storeAddToCartUrl as string,
		};
	});
}

export { parseJsonRegions };
export type { Region };
